export * from '@fhs/routing/src/routes/v2/order/[orderId]';
export { default } from '@fhs/routing/src/routes/v2/order/[orderId]';
